"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SegmentTracker = void 0;
var analytics_browser_client_1 = require("./clients/analytics-browser-client");
var http_client_1 = require("./clients/http-client");
var SegmentTracker = /** @class */ (function () {
    /**
     * Creates a SegmentTracker instance.
     *
     * @param segmentWriteKey The Segment write key for tracking events.
     * @param options Optional configuration options.
     * @remarks When using `useHttpClient: true`, the `nonDestinationWriteKey` option is mandatory.
     */
    function SegmentTracker(segmentWriteKey, options) {
        if (options === void 0) { options = {}; }
        this.segmentClient = this.getDefaultClient(segmentWriteKey, options);
        this.excludedEvents = options.excludeEvents || ['scroll'];
    }
    /**
     * Tracks an event with Segment.
     * @returns A Promise that resolves with a TrackerResponse object:
     *          - On success: { success: true }
     *          - On failure: { success: false, message: <error message> }
     */
    SegmentTracker.prototype.track = function (event) {
        return __awaiter(this, void 0, void 0, function () {
            var eventName, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        eventName = event.eventName;
                        if (!eventName || !this.isEventAllowed(eventName)) {
                            return [2 /*return*/, {
                                    success: false,
                                    message: "Event '".concat(eventName, "' is not allowed for tracking."),
                                }];
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.segmentClient.track(event)];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, { success: true }];
                    case 3:
                        error_1 = _a.sent();
                        return [2 /*return*/, {
                                success: false,
                                message: "Error tracking event '".concat(eventName, "': ").concat(error_1 === null || error_1 === void 0 ? void 0 : error_1.message),
                            }];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Identifies a user with Segment.
     * @returns A Promise that resolves with a TrackerResponse object:
     *          - On success: { success: true }
     *          - On failure: { success: false, message: <error message> }
     */
    SegmentTracker.prototype.identify = function (event) {
        return __awaiter(this, void 0, void 0, function () {
            var error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.segmentClient.identify(event)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, { success: true }];
                    case 2:
                        error_2 = _a.sent();
                        return [2 /*return*/, {
                                success: false,
                                message: "Error identifying: ".concat(error_2 === null || error_2 === void 0 ? void 0 : error_2.message),
                            }];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Sends a page view event to Segment, identifying the current user and
     * the page they are viewing.
     * @returns A Promise that resolves with a TrackerResponse object:
     *          - On success: { success: true }
     *          - On failure: { success: false, message: <error message> }
     */
    SegmentTracker.prototype.page = function (event) {
        return __awaiter(this, void 0, void 0, function () {
            var error_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.segmentClient.page(event)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, { success: true }];
                    case 2:
                        error_3 = _a.sent();
                        return [2 /*return*/, {
                                success: false,
                                message: "Error sending page event: ".concat(error_3 === null || error_3 === void 0 ? void 0 : error_3.message),
                            }];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    SegmentTracker.prototype.getDefaultClient = function (segmentWriteKey, options) {
        if (options === void 0) { options = {}; }
        if (options.useHttpClient) {
            if (!options.nonDestinationWriteKey) {
                throw new Error('The `nonDestinationWriteKey` option is required when using the HTTP client.');
            }
            return new http_client_1.SegmentHttpClient(segmentWriteKey, new analytics_browser_client_1.AnalyticsBrowserClient(options.nonDestinationWriteKey, options === null || options === void 0 ? void 0 : options.segmentOptions));
        }
        return new analytics_browser_client_1.AnalyticsBrowserClient(segmentWriteKey, options === null || options === void 0 ? void 0 : options.segmentOptions);
    };
    SegmentTracker.prototype.isEventAllowed = function (eventName) {
        return !this.excludedEvents.includes(eventName);
    };
    return SegmentTracker;
}());
exports.SegmentTracker = SegmentTracker;
